import React, { useEffect, useState, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from '../axios';
import EventImg from '../img/events/event-view.jpg';
import HeaderSecond from '../HeaderSecond';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ShareEvent from './ShareEvent';
import NoEventImg from '../img/events/no-events.png';
import BreadcrumbBg from '../img/banner/breadcrumb-bg.jpg'
import Loader from '../Loader';
import LoaderImg from '../img/logo/running.gif';
import EventView from '../../src/img/events/event-view.jpg'

const SearchEvent = (props) => {
    const navigate = useNavigate()
    // BELOW 3 STATES ARE FROM LOCATION
    const [EventName, setEventName] = useState(''); // FROM Header.js
    const [CategoryFilter, setCategoryFilter] = useState(''); //FROM CategorySection.js getting category_id
    const [QuicklyFilter, setQuicklyFilter] = useState(''); // FROM CategorySection.js gettings quick filter 
    const [EventVenue, setEventVenue] = useState('');
    const [EventsData, setEventsData] = useState([]);
    const [TempVenue, setTempVenue] = useState('');
    // SEARCHING FILTERS
    const [AllType, setAllType] = useState([]);
    const [EndDate, setEndDate] = useState('');
    const [StartDate, setStartDate] = useState('');
    const [City, setCity] = useState('');
    const [State, setState] = useState('');
    const [Country, setCountry] = useState('');
    const [AllCity, setAllCity] = useState([]);
    const [Index, setIndex] = useState(15);
    const [ApiCall, setApiCall] = useState(false);
    const [TotalEvent, setTotalEvent] = useState(0);
    const [AllDistance, setAllDistance] = useState([]);
    const [Distance, setDistance] = useState(0);
    const [DistanceApiCall, setDistanceApiCall] = useState(true);

    const [ShareEventFlag, setShareEventFlag] = useState(false);
    const [EventIdShareEvent, setEventIdShareEvent] = useState('');
    const [Val, setVal] = useState('');
    const [suggestions, setSuggestions] = useState([]);
    const [ShowSuggestion, setShowSuggestion] = useState(false);

    const [CityApiCall, setCityApiCall] = useState(true);
    const DivRef = useRef(null);
    const DivRef1 = useRef(null);
    const DivRef2 = useRef(null);
    const [Login, setLogin] = useState(false);
    const [FilterDiv, setFilterDiv] = useState(false);
    const [Loader, setLoader] = useState(false);
    const [ApiCall1, setApiCall1] = useState(true);
    const [CategoryData, setCategoryData] = useState([]);
    const [pageRefreshed, setPageRefreshed] = useState(false);
    const [EventListData, setEventListData] = useState([]);
    const [EventList, setEventList] = useState('');
    const [Val1, setVal1] = useState('');
    const [EventSuggestions, setEventSuggestions] = useState([]);
    const [ShowSuggestion1, setShowSuggestion1] = useState(false);
    
    const [AllLocation, setAllLocation] = useState([]);
    const [Location, setLocation] = useState('');
    const [Suggestions2, setSuggestions2] = useState([]);
    const [ShowSuggestion2, setShowSuggestion2] = useState(false);
     const [Val3, setVal3] = useState('');  
    const location = useLocation();
    const [FeaturedEventsFilter, setFeaturedEventsFilter] = useState(0);
    // console.log("location : " + location);
    // console.log("filter from : " + location.state.filter_name);
    // console.log("filter name : " + location.state.filter);

    useEffect(() => {
        if(location.state){
            if (pageRefreshed && location.state.category_id == "") {
                navigate('/events', { state: [] });
                setApiCall(true);
            }
        }
    }, [navigate, pageRefreshed, location.state]);
   
    // console.log("location state:", location.state);
    useEffect(() => {
        if (location.state) {
            // console.log(location.state);
            if (location.state.category_id != "") {
                setCategoryFilter(location.state.category_id);
                setApiCall(true);
            }

            if (location.state.city_id) {
                setCity(location.state.city_id);
                setCityApiCall(true);
            }

            if (location.state.filter_name !== "") {
                if (location.state.filter_name === "quick_filter") {
                    // console.log("quick");
                    setQuicklyFilter(location.state.filter);
                    setApiCall(true);
                } else if (location.state.filter_name === "event_name") {
                    // console.log("event : "+location.state.filter);
                    // return false;
                    setEventName(location.state.filter);
                    setEventVenue(location.state.filter);
                    // console.log(location.state.filter);
                    setApiCall(true);
                }
            }

            if (location.state.featured_event != "") {
                setFeaturedEventsFilter(location.state.featured_event);
                setApiCall(true);
            }

            // if (location.state.from_popular_events === 1) {
            //     setApiCall(false);
            //     // setEventsData(location.state.popular_events);
            //     // setTotalEvent(location.state.popular_events.length)

            //     const payload = {
            //         city: localStorage.getItem("CityId"),
            //         scity: localStorage.getItem("CityId"),
            //         state: localStorage.getItem("StateId"),
            //         country: localStorage.getItem("CountryId")
            //     }
            //     // console.log(payload);
            //     axios.post("get_data_location_wise", payload)
            //         .then((response) => {
            //             setEventsData(response.data.data.eventData);
            //             setTotalEvent(response.data.data.eventData.length);
            //         })
            //         .catch((error) => {
            //             console.log(error);
            //         })

            // }
        }
    }, [location.state])

    // console.log(EventVenue);
    // console.log(location.state.category_id, CategoryFilter);

    useEffect(() => {
        if (ApiCall1) {
            axios.post('getCategoryEventsCount')
                .then((response) => {
                    // console.log(response.data.data);
                    if (response.status === 200) {
                        setApiCall1(false);
                        setCategoryData(response.data.data.category_data);
                    }
                })
                .catch((error) => {
                    console.log(error);
                })
        }
    }, [ApiCall1])

    // console.log(EventName);

    // console.log(EventListData); AllType
    //console.log(ApiCall, CategoryFilter);
    useEffect(() => {
        if (ApiCall) {
            // console.log(EventName, EventList);
            setLoader(true);
            const payload = {
                // FROM CATEGORY EITHER CATEGORY ID OR QUICK FILTER
                event_name: EventName ? EventName : EventList ? EventList : Val1,
                filter: QuicklyFilter,
                category_id: CategoryFilter,
                start_date: StartDate,
                end_date: EndDate,
                distance: Distance,
                country: Country,
                state: State,
                city: City ? City : Val ? Val : '',
                location: Location ? Location : Val3 ? Val3 : '',
                featured_event : FeaturedEventsFilter ? FeaturedEventsFilter : 0,
                event_venue: typeof EventVenue === 'string' ? EventVenue : ''
            };
            // console.log(payload);
            axios.post("events", payload)
                .then((response) => {
                    const EventAllData = response.data.data.EventData;
                    // console.log(response.data.data.EventData, EventVenue);
                    if(typeof EventVenue === 'string' && EventVenue !== ''){
                        const venues = EventAllData.find(e => e.venue?.toLowerCase().includes(EventVenue.toLowerCase()))?.venue || '';
                        setTempVenue(venues ? venues : '');
                    }
                    setCityApiCall(true);
                    setApiCall(false);
                    setEventsData(EventAllData);
                    setTotalEvent(EventAllData.length)
                    setLoader(false);
                    setFilterDiv(false);

                })
                .catch((error) => {
                    console.log(error);
                    setLoader(false);
                })
        }
    }, [ApiCall, EventName, QuicklyFilter, CategoryFilter, StartDate, Country, State, City, EndDate, location.state])

    const handleSubmit = (e, type) => {
        // console.log(type);
        if (type === 'quick_filter') setQuicklyFilter(e.target.value);
        // console.log(QuicklyFilter);
        e.preventDefault();
        setApiCall(true);
    }
    const HandleClear = (e) => {
        e.preventDefault();
      
        setStartDate(''); setCategoryFilter(0); setCountry(''); setCity(''); setState('');
        setQuicklyFilter(''); setEventName(''); setEndDate(''); setDistance(0); setVal('');
        setAllType([]); setAllDistance([]); setEventList(''); setVal1(''); setLocation('');
        setVal3(''); setApiCall(true); setFeaturedEventsFilter(0); setEventVenue('');
        setTempVenue('');
    }
    //console.log(TempVenue);
    
         // GET ALL EVENT Types(CATEGORY)

    // GET ALL CITIES
    const CountryId = localStorage.getItem("CountryId") ? localStorage.getItem("CountryId") : 101;
    useEffect(() => {
        if (CityApiCall || City) {
            // console.log(TempVenue);
            axios.post('city', {
                country_id: CountryId,
                search_flag: 1
            })
                .then((response) => {
                    // console.log(response.data.data.AllLocation);
                    if (response.data.status === 200) {
                        setAllCity(response.data.data.AllCities);
                        setCityApiCall(false);
                        setAllLocation(response.data.data.AllLocation);
                        //------------- New added
                        if(City){
                            const item = response.data.data.AllCities.find(x => x.id == City);
                            if (item) {
                                setVal(item.name);
                            }
                        }

                        if(TempVenue){
                            const item1 = response.data.data.AllLocation.find(x => x.venue == TempVenue);
                            // console.log(item1, TempVenue);
                            if (item1) {
                                setVal3(item1.venue);
                            }
                        }
                    }
                })
                .catch((error) => {
                    console.log(error);
                })
        }
    }, [CityApiCall, CountryId, City])
    // console.log(AllCity);
    
    useEffect(() => {
        // if (AllType.length === 0) {
        axios.get('types')
            .then((response) => {
                // console.log(response.data.data);
                if (response.data.status === 200) {
                    setAllType(response.data.data.AllEventTypes);
                    setEventListData(response.data.data.AllEventDetails);
                    
                    //------------- New added
                    if(EventName){
                        const item = response.data.data.AllEventDetails.find(x => x.id == EventName);
                      
                        if (item) {
                            setVal1(item.name);
                        }else{
                            if(TempVenue === ""){
                                // console.log('aa', TempVenue);
                                setVal1(EventName);
                            }
                        }
                    }
                }
            })
            .catch((error) => {
                console.log(error);
            })
        // }
    }, [EventName])
    
    const HandleBack = (e) => {
        const CountryCode = localStorage.getItem("CountryCode");
        const CityName = localStorage.getItem("City") ? localStorage.getItem("City") : localStorage.getItem("Country");
        navigate("/" + CountryCode + "/" + CityName);
    }

    const handleWishList = (eventId, is_follow) => {
        // alert("here");
        // is_follow == 0 then need to follow means add entry in table
        // is_follow == 1 then need to unfollow means delete the entry form table
        const RacesToken = localStorage.getItem("RacesToken") ? localStorage.getItem("RacesToken") : "";
        if (RacesToken) {
            const payload = {
                "event_id": eventId,
                "is_follow": is_follow
            }
            axios.post("/follow", payload)
                .then((response) => {
                    // console.log(response.data.message);
                    if (response.status) {
                        toast.success(response.data.message);
                        // setApiCall(true)
                    }
                })
                .catch((error) => {
                    if (error.response) {
                        console.log('Error occured while adding to wishlist')
                    }
                })
        } else {
            // const CountryCode = localStorage.getItem("CountryCode");
            // const CityName = localStorage.getItem("City") ? localStorage.getItem("City") : localStorage.getItem("Country");
            // navigate("/" + CountryCode + "/" + CityName, { state: { "login_popup": true } });
            setLogin(true);
        }
    }
    const handleShareEvent = (eventId, eventName) => {
        setShareEventFlag(true);
        setEventName(eventName);
        setEventIdShareEvent(eventId);
    }
   
    const handleInputChange = (e) => {
        const value = e.target.value;
        // console.log(AllCity);
        setVal(value);
        if (value === "") {
            setCity('');
            // handleSubmit(e)
        }
        // Filter suggestions based on input value
        const filteredSuggestions = AllCity.filter((item) =>
            item.name.toLowerCase().includes(value.toLowerCase())
        );

        const SliceArr = filteredSuggestions.slice(0, 5)
        // console.log(SliceArr);
        setSuggestions(SliceArr);
        setShowSuggestion(true);
    };
    const handleSuggestionClick = (e, id, name) => {
        setCity(id);
        setVal(name)
        setSuggestions([]);
        // handleSubmit(e)
    };
    const handleClose = (e) => {
        if (DivRef.current && !DivRef.current.contains(e.target)) {
            setShowSuggestion(false);
        }

        if (DivRef1.current && !DivRef1.current.contains(e.target)) {
            setShowSuggestion1(false);
        }
    }

    //---------- event
     const handleEventChange = (e) => {
        const value = e.target.value;
        setVal1(value);
        if (value === "") {
            setEventList('');
            // handleSubmit(e)
        }
        // Filter suggestions based on input value
        const filteredSuggestions = EventListData.filter((item) =>
            item.name.toLowerCase().includes(value.toLowerCase())
        );

        const SliceArr = filteredSuggestions.slice(0, 5)
        // console.log(SliceArr);
        setEventSuggestions(SliceArr);
        setShowSuggestion1(true);
    };
    const handleEventSuggestionClick = (e, id, name) => {
        setEventList(id);
        setVal1(name)
        setEventSuggestions([]);
        setEventName(''); setEventVenue(''); setLocation('');
        setVal3(''); setTempVenue(''); location.state = null  
    };
    // console.log(Val1);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                DivRef.current &&
                !DivRef.current.contains(event.target)
            ) {
                setShowSuggestion1(false);
            }

            if (
                DivRef2.current &&
                !DivRef2.current.contains(event.target)
            ) {
                setShowSuggestion2(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    //------- location/venue
    const handleLocationInputChange = (e) => {
        const value = e.target.value;
        // console.log(AllCity);
        setVal3(value);
        if (value === "") {
            setLocation('');
            // handleSubmit(e)
        }
        // Filter suggestions based on input value
        const filteredSuggestions = AllLocation.filter((item) =>
            item.venue.toLowerCase().includes(value.toLowerCase())
        );

        const SliceArr = filteredSuggestions.slice(0, 5)
        // console.log(SliceArr);
        setSuggestions2(SliceArr);
        setShowSuggestion2(true);
    };
   
    const handleLocationSuggestionClick = (e, id, venue) => {
        setLocation(venue);
        setVal3(venue)
        setSuggestions2([]);
    };
    

    useEffect(() => {
        // Check if the current location is different from the previous one
        const isPageRefreshed = window.performance && window.performance.navigation.type === window.performance.navigation.TYPE_RELOAD;
        // If the page is refreshed, update the state
        if (isPageRefreshed) {
            setPageRefreshed(true);
        }
    }, []);

    const handleEventDetails = (e, EventId, EventName) => {
        navigate("/e/"+EventName.replace(/\s/g, '_'));
    }

    return (
        <>
            {Loader ? <div><div id='loader' style={{ backgroundImage: `url(${LoaderImg})` }}></div></div> : null}

            <ToastContainer theme="colored" />
            <HeaderSecond Login={Login} setLogin={setLogin} />
            {ShareEventFlag ? <ShareEvent setShareEventFlag={setShareEventFlag} EventName={EventName} EventIdShareEvent={EventIdShareEvent} /> : null}
            <main className="main__content_wrapper">
                <section className="breadcrumb__section breadcrumb__bg" style={{ backgroundImage: `url(${BreadcrumbBg})` }} >
                    <div className="container">
                        <div className="row row-cols-1">
                            <div className="col">
                                <div className="breadcrumb__content">
                                    <h1 className="breadcrumb__content--title text-white mb-10">
                                        Explore Events
                                    </h1>
                                    {/* <ul className="breadcrumb__content--menu d-flex">
                                        <li className="breadcrumb__content--menu__items">
                                            <div className="text-white" onClick={(e) => HandleBack(e)}>
                                                Home
                                            </div>
                                        </li>
                                        <li className="breadcrumb__content--menu__items">
                                            <span className="text-white">Search Event</span>
                                        </li>
                                    </ul> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="py-5">
                    <div className="container-fluid" onClick={(e) => { handleClose(e) }}>
                        <div className="row" >

                            {/* START FILTER DIV */}
                            <div className="col-xl-3 col-lg-4">
                                <div className={FilterDiv ? "event-filters widget__area" : "widget__area d-md-2-none "}>
                                    <div className="single__widget widget__bg">
                                        <div className="d-flex justify-content-between">
                                            <h2 className="widget__title position__relative h3 m-0">

                                                <svg xmlns="http://www.w3.org/2000/svg" height="30" viewBox="0 -960 960 960" width="30"><path d="M200-160v-280h-80v-80h240v80h-80v280h-80Zm0-440v-200h80v200h-80Zm160 0v-80h80v-120h80v120h80v80H360Zm80 440v-360h80v360h-80Zm240 0v-120h-80v-80h240v80h-80v120h-80Zm0-280v-360h80v360h-80Z" /></svg> Filters</h2>

                                            <svg onClick={(e) => HandleBack(e)} className="back-to-home" xmlns="http://www.w3.org/2000/svg" height="30" viewBox="0 -960 960 960" width="30"><path d="M240-200h120v-240h240v240h120v-360L480-740 240-560v360Zm-80 80v-480l320-240 320 240v480H520v-240h-80v240H160Zm320-350Z" /></svg>

                                            <svg onClick={(e) => setFilterDiv(false)} className="event-filters-close-btn" xmlns="http://www.w3.org/2000/svg" height="30" viewBox="0 -960 960 960" width="30"><path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z" /></svg>
                                        </div>

                                        {/* <form onSubmit={(e) => handleSubmit(e,'')}> */}
                                        <div className="checkout__input--list">
                                           
                                            {/* <div className="checkout__input--list my-5">
                                                <label className="checkout__input--label mb-2">
                                                    By Event Name
                                                </label>
                                                <input
                                                    className="checkout__input--field border-radius-5"
                                                    placeholder="Search by event name"
                                                    type="text"
                                                    value={EventName}
                                                    onChange={(e) => { setEventName(e.target.value); }}
                                                />
                                            </div> */}

                                            <div className="checkout__input--list my-5">
                                                <label className="checkout__input--label mb-3">
                                                    Event Name
                                                </label>
                                                <input className="predictive__search--input" placeholder="Select Event Name" type="text" onChange={(e) => { handleEventChange(e); }} value={Val1} />
                                                <div className="autocomplete" style={{ cursor: 'pointer' }}>
                                                    {ShowSuggestion1 ?
                                                        <ul ref={DivRef} style={{ position: 'relative', width: '100%' }}>
                                                            {
                                                                (EventSuggestions.length > 0) ?
                                                                    EventSuggestions.map((item) => {
                                                                        // console.log(item);
                                                                        return (
                                                                            <li key={item.id}
                                                                                onClick={(e) => handleEventSuggestionClick(e, item.id, item.name)}
                                                                            >{item.name}</li>
                                                                        )
                                                                    }) : null
                                                            }
                                                        </ul>
                                                        : null
                                                    }
                                                </div>
                                            </div>

                                            <div className="checkout__input--list my-5">
                                                <label className="checkout__input--label mb-3">
                                                    City
                                                </label>
                                                <input className="predictive__search--input" placeholder="Select City" type="text" onChange={(e) => { handleInputChange(e); }} value={Val} />
                                                <div className="autocomplete" style={{ cursor: 'pointer' }}>
                                                    {ShowSuggestion ?
                                                        <ul ref={DivRef} style={{ position: 'relative', width: '100%' }}>
                                                            {
                                                                (suggestions.length > 0) ?
                                                                    suggestions.map((item) => {
                                                                        // console.log(item);
                                                                        return (
                                                                            <li key={item.id}
                                                                                onClick={(e) => handleSuggestionClick(e, item.id, item.name)}
                                                                            >{item.name}</li>
                                                                        )
                                                                    }) : null
                                                            }
                                                        </ul>
                                                        : null
                                                    }
                                                </div>
                                            </div>

                                            <div className="checkout__input--list my-5">
                                                <label className="checkout__input--label mb-3">
                                                    Location/Venue
                                                </label>
                                                <input className="predictive__search--input" placeholder="Select Location/Venue" type="text" onChange={(e) => { handleLocationInputChange(e); }} value={Val3} />
                                                <div className="autocomplete" style={{ cursor: 'pointer' }}>
                                                    {ShowSuggestion2 ?
                                                        <ul ref={DivRef2} style={{ position: 'relative', width: '100%' }}>
                                                            {
                                                                (Suggestions2.length > 0) ?
                                                                    Suggestions2.map((item) => {
                                                                        // console.log(item);
                                                                        return (
                                                                            <li key={item.id}
                                                                                onClick={(e) => handleLocationSuggestionClick(e, item.id, item.venue)}
                                                                            >{item.venue}</li>
                                                                        )
                                                                    }) : null
                                                            }
                                                        </ul>
                                                        : null
                                                    }
                                                </div>
                                            </div>

                                            <div className="checkout__input--list my-5">
                                                <label className="checkout__input--label mb-3">
                                                    Category
                                                </label>
                                                <div className="checkout__input--select select">
                                                    <select
                                                        className="checkout__input--select__field border-radius-5"
                                                        onChange={(e) => {
                                                            setCategoryFilter(e.target.value);
                                                            
                                                        }}
                                                        value={CategoryFilter} // Set the value prop here
                                                    >
                                                        <option value={0}>Select Category Type</option>
                                                        {CategoryData && CategoryData.length > 0 ? (
                                                            CategoryData.map((item) => (
                                                                <option key={item.id} value={item.id}>
                                                                    {item.name}
                                                                </option>
                                                            ))
                                                        ) : null}
                                                    </select>
                                                </div>
                                            </div>

                                            <div className="checkout__input--list my-5">
                                                <label className="checkout__input--label mb-3">
                                                    Registration Start Date
                                                </label>
                                                <input
                                                    className="checkout__input--field border-radius-5 position-relative"
                                                    placeholder="" type="date"
                                                    value={StartDate}
                                                    onChange={(e) => { setStartDate(e.target.value); }}
                                                />
                                            </div>

                                            <div className="checkout__input--list my-5">
                                                <label className="checkout__input--label mb-3">
                                                    Registration Closing on
                                                </label>
                                                <input
                                                    className="checkout__input--field border-radius-5 position-relative"
                                                    placeholder="" type="date"
                                                    value={EndDate}
                                                    onChange={(e) => { setEndDate(e.target.value); }}
                                                />
                                            </div>

                                            <br />
                                            <div className="checkout__content--step__footer d-flex align-items-center flex-row justify-content-center gap-4 hand_cursor">
                                                 
                                                <div className="continue__shipping--btn secondary__btn border-radius-5"
                                                    onClick={(e) => HandleClear(e)}>
                                                    Clear
                                                </div>
                                                <div className="continue__shipping--btn primary__btn border-radius-5"
                                                    onClick={(e) => handleSubmit(e)}>
                                                    Search
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* END FILTER DIV */}

                            <div className="col-xl-9 col-lg-8">
                                <div className="shop__header bg__gray--color d-flex align-items-center justify-content-between mb-30">
                                    <button className="widget__filter--btn d-none d-md-2-flex align-items-center" onClick={(e) => setFilterDiv(true)}>
                                        <svg
                                            className="widget__filter--btn__icon"
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 512 512"
                                        >
                                            <path
                                                fill="none"
                                                stroke="currentColor"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth={28}
                                                d="M368 128h80M64 128h240M368 384h80M64 384h240M208 256h240M64 256h80"
                                            />
                                            <circle
                                                cx={336}
                                                cy={128}
                                                r={28}
                                                fill="none"
                                                stroke="currentColor"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth={28}
                                            />
                                            <circle
                                                cx={176}
                                                cy={256}
                                                r={28}
                                                fill="none"
                                                stroke="currentColor"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth={28}
                                            />
                                            <circle
                                                cx={336}
                                                cy={384}
                                                r={28}
                                                fill="none"
                                                stroke="currentColor"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth={28}
                                            />
                                        </svg>
                                        <span className="widget__filter--btn__text">Filter</span>
                                    </button>

                                    <div className="product__view--mode__list product__short--by align-items-center d-none d-lg-flex">
                                        <p className="product__showing--count m-0">Showing {TotalEvent !== 0 ? 1 : 0}–{Index < TotalEvent ? Index : TotalEvent} of {TotalEvent} results</p>
                                    </div>

                                    {/* <div className="product__view--mode d-flex align-items-center">

                                        <div className="product__view--mode__list product__short--by align-items-center d-none d-lg-flex">
                                            < div className="select shop__header--select">
                                                <select className="product__view--select" onChange={(e) => handleSubmit(e, 'quick_filter')}>
                                                    <option value={1}>Sort by latest</option>
                                                    <option value="weekend" selected={QuicklyFilter === "weekend"}>Weekend</option>
                                                    <option value="week" selected={QuicklyFilter === "week"}>Week</option>
                                                    <option value="month" selected={QuicklyFilter === "month"}>Month</option>
                                                    <option value="tomorrow" selected={QuicklyFilter === "tomorrow"}>Tomorrow</option>
                                                    <option value="today" selected={QuicklyFilter === "today"}>Today</option>
                                                </select>
                                            </div>
                                        </div>

                                    </div> */}

                                    <div className="product__view--mode d-flex align-items-center">
                                        <div className="product__view--mode__list product__short--by align-items-center d-none d-lg-flex">
                                            <div className="select shop__header--select">
                                                <select
                                                    className="product__view--select"
                                                    onChange={(e) => handleSubmit(e, 'quick_filter')}
                                                    value={QuicklyFilter}
                                                >
                                                    <option value={1}>Sort by latest</option>
                                                    <option value="tomorrow">Tomorrow</option>
                                                    <option value="week">This Week</option>
                                                    <option value="month">This Month</option>
                                                    {/* <option value="weekend">Weekend</option> */}
                                                    <option value="quarter">This Quarter</option>
                                                    <option value="today">Today</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>



                                </div>

<div className="shop__product--wrapper">
{/* EVENTS LISTING TABLE START HERE */}
<div className="tab_content">
    <div className="tab_pane active show">
        <div className="product__section--inner product__grid--inner">
            {/* {console.log(EventsData)} */}
            {
                EventsData && EventsData.length > 0 ? (
                    <div className="row">
                        {EventsData.map((event, index) => {
                            // console.log(Index,index);
                            return (
                                ((Index) > parseInt(index)) ?
                                    // <div key={index} className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-4 my-4">
                                    <div key={index} className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-4 col-xxl-4 py-4" style={{ position: "relative" }}>
                                        <div key={event.id} className="product__items"
                                            onClick={(e) => { handleEventDetails(e, event.id, event.name) }}

                                        >
                                            <div className="product__items--thumbnail" >

                                                <div className="product__items--link">
                                                    <img
                                                        className="product__items--img product__primary--img"
                                                        src={event.banner_image || EventView}
                                                        alt="Event View"
                                                        style={{ height: '230px', objectFit: 'fill' }}
                                                    />
                                                </div>

                                                {/* New Event date */}
                                                <div className='event-date-card'>
                                                    <p className="m-0 event-month-value">{event.start_event_month ? event.start_event_month : null}</p>
                                                    <p className="m-0 event-date-value">{event.start_event_date ? event.start_event_date : null}</p>
                                                </div>
                                                
                                                <div className="product__badge style1 special-badge gap-1" >
                                                    <svg xmlns="http://www.w3.org/2000/svg" height="15px" viewBox="0 -960 960 960" width="15px" fill="#323131ff"><path d="M480-480q33 0 56.5-23.5T560-560q0-33-23.5-56.5T480-640q-33 0-56.5 23.5T400-560q0 33 23.5 56.5T480-480Zm0 294q122-112 181-203.5T720-552q0-109-69.5-178.5T480-800q-101 0-170.5 69.5T240-552q0 71 59 162.5T480-186Zm0 106Q319-217 239.5-334.5T160-552q0-150 96.5-239T480-880q127 0 223.5 89T800-552q0 100-79.5 217.5T480-80Zm0-480Z" /></svg> {event.city_name}
                                                </div>
                                                
                                                {event.TicketDetails && event.TicketDetails.length > 0 && (
                                                    event.TicketDetails.some(ticket => (parseInt(ticket.show_early_bird) === 1 && parseInt(ticket.ticket_status) !== 2)) ? (

                                                        <div className="product__badge_early_bird style1 special-badge gap-1" title='Early Bird'>
                                                            {/* Early Bird */}
                                                            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#ffffff"><path d="M480-80q-24 0-46-9t-39-26q-29-29-50-38t-63-9q-50 0-85-35t-35-85q0-42-9-63t-38-50q-17-17-26-39t-9-46q0-24 9-46t26-39q29-29 38-50t9-63q0-50 35-85t85-35q42 0 63-9t50-38q17-17 39-26t46-9q24 0 46 9t39 26q29 29 50 38t63 9q50 0 85 35t35 85q0 42 9 63t38 50q17 17 26 39t9 46q0 24-9 46t-26 39q-29 29-38 50t-9 63q0 50-35 85t-85 35q-42 0-63 9t-50 38q-17 17-39 26t-46 9Zm100-240q25 0 42.5-17.5T640-380q0-25-17.5-42.5T580-440q-25 0-42.5 17.5T520-380q0 25 17.5 42.5T580-320Zm-202-2 260-260-56-56-260 260 56 56Zm2-198q25 0 42.5-17.5T440-580q0-25-17.5-42.5T380-640q-25 0-42.5 17.5T320-580q0 25 17.5 42.5T380-520Z" /></svg>
                                                        </div>
                                                    ) : null
                                                )}
            
                                            </div>

                                            {/* event info */}
                                            <div className="product__items--content cursor-pointer" >

                                                {/* Event Name */}
                                                <div className=" pt-2">
                                                    <h4 className="h4 d-flex" style={{ height: "55px", overflow: "hidden" }}>  {event.display_name}</h4>
                                                </div>

                                                {/* Location and like & share btn */}
                                                <div className="row d-flex align-items-center py-3" style={{ borderBottom: "1px dashed #c7c7c7" }}>
                                                    <div className="col-7 col-sm-7">
                                                        {event.venue ?
                                                            <p className='card-rgn-txt overflow-text'> <strong>
                                                                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#383434"><path d="M480-480q33 0 56.5-23.5T560-560q0-33-23.5-56.5T480-640q-33 0-56.5 23.5T400-560q0 33 23.5 56.5T480-480Zm0 294q122-112 181-203.5T720-552q0-109-69.5-178.5T480-800q-101 0-170.5 69.5T240-552q0 71 59 162.5T480-186Zm0 106Q319-217 239.5-334.5T160-552q0-150 96.5-239T480-880q127 0 223.5 89T800-552q0 100-79.5 217.5T480-80Zm0-480Z" /></svg> <span className="rgn-date">{event.venue}</span></strong>
                                                            </p>
                                                        : null }
                                                    </div>

                                                    <div className="col-5 col-sm-5 ps-0">
                                                        <ul className="product__items--action d-flex justify-content-end">

                                                            {/* Wishlist */}
                                                            <li className="product__items--action__list ">
                                                                <div className={event.is_follow ? "hand_cursor product__items--action__btn wishlisted" : "hand_cursor product__items--action__btn action-favourites"} onClick={(e) => {
                                                                    e.stopPropagation(); // Stop event propagation
                                                                    handleWishList(event.id, event.is_follow);
                                                                }}>


                                                                    <svg className="product__items--action__btn--svg" xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 -960 960 960" width="18px" transform="translate(0 0)" fill="currentColor"><path d="m480-120-58-52q-101-91-167-157T150-447.5Q111-500 95.5-544T80-634q0-94 63-157t157-63q52 0 99 22t81 62q34-40 81-62t99-22q94 0 157 63t63 157q0 46-15.5 90T810-447.5Q771-395 705-329T538-172l-58 52Z" /></svg>

                                                                    <span className="visually-hidden">Favourites</span>
                                                                </div>
                                                            </li>

                                                            <li className="product__items--action__list">
                                                                <div className="product__items--action__btn hand_cursor action-share" onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    handleShareEvent(event.id, event.name)
                                                                }}>


                                                                    <svg className="product__items--action__btn--svg" xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 -960 960 960" width="18px" transform="translate(0 0)" fill="currentColor"><path d="M680-80q-50 0-85-35t-35-85q0-6 3-28L282-392q-16 15-37 23.5t-45 8.5q-50 0-85-35t-35-85q0-50 35-85t85-35q24 0 45 8.5t37 23.5l281-164q-2-7-2.5-13.5T560-760q0-50 35-85t85-35q50 0 85 35t35 85q0 50-35 85t-85 35q-24 0-45-8.5T598-672L317-508q2 7 2.5 13.5t.5 14.5q0 8-.5 14.5T317-452l281 164q16-15 37-23.5t45-8.5q50 0 85 35t35 85q0 50-35 85t-85 35Z" /></svg>


                                                                    <span className="visually-hidden">Compare</span>
                                                                </div>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>


                                                {/* amount and action btn */}
                                                <div className="amt-action-div py-3 px-2">
                                                    <div className="">
                                                        {event.TicketDetails && event.TicketDetails.length > 0 ?
                                                        <h4 className="h4 d-flex align-items-center gap-1">
                                                            
                                                            {/* <svg xmlns="http://www.w3.org/2000/svg" height="22px" viewBox="0 -960 960 960" width="22px" fill="currentColor"><path d="M549-120 280-400v-80h140q53 0 91.5-34.5T558-600H240v-80h306q-17-35-50.5-57.5T420-760H240v-80h480v80H590q14 17 25 37t17 43h88v80h-81q-8 85-70 142.5T420-400h-29l269 280H549Z" /></svg>

                                                            {event.TicketDetails && event.TicketDetails.length > 0 && (
                                                                event.TicketDetails.some(ticket => parseInt(ticket.ticket_status) === 2) ? (
                                                                    <span>Free</span>
                                                                ) : (

                                                                    event.TicketDetails.map((ticket, index) => (
                                                                        parseInt(ticket.ticket_status) === 1 && (
                                                                            <span key={index}>
                                                                                {ticket.show_early_bird === 1 ? (
                                                                                    <span > {ticket.ticket_price}</span>
                                                                                ) : (
                                                                                    <span>{ticket.ticket_price}</span>
                                                                                )}
                                                                            </span>
                                                                        )
                                                                    ))
                                                                )
                                                            )}
                                                            <small className="fw-normal fs-5 mt-1"> Onwards</small> */}

                                                            {event.TicketDetails && event.TicketDetails.length > 0 && (
                                                            event.TicketDetails.some(ticket => parseInt(ticket.ticket_status) === 2) ? (
                                                                <span className="current__price m-0">Free</span>
                                                            ) : (
                                                                event.TicketDetails.map((ticket, index) => (
                                                                parseInt(ticket.ticket_status) === 1 && (
                                                                    <span key={index}>
                                                                    {index > 0 && " - "}
                                                                    {ticket.show_early_bird === 1 ? (
                                                                        <span className="text-left">
                                                                        <span className="ticket-prices">
                                                                            <span className="original-price"> ₹{ticket.ticket_price}</span>&nbsp;
                                                                            <span className="current__price m-0">₹{ticket.discount_ticket_price}</span>
                                                                        </span>
                                                                        </span>
                                                                    ) : (
                                                                        <span className="current__price m-0">₹{ticket.ticket_price}</span>
                                                                    )}
                                                                    <small className="fw-normal fs-5 mt-1"> Onwards</small>
                                                                    </span>
                                                                )
                                                                ))
                                                            )
                                                            )}
                                                            
                                                            </h4>
                                                            : null }
                                                    </div>
                                                    {event.registration_close_flag == 0 ?
                                                        <div className="">
                                                            <h4 className="h4 register-btn-link">Register Now <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="currentColor"><path d="M647-440H160v-80h487L423-744l57-56 320 320-320 320-57-56 224-224Z" /></svg></h4>

                                                            <div className='product__items--action__btn hand_cursor register-btn-icon'> 
                                                                <svg className="product__items--action__btn--svg" xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 -960 960 960" width="18px" transform="translate(0 0)" fill="currentColor"><path d="M647-440H160v-80h487L423-744l57-56 320 320-320 320-57-56 224-224Z" /></svg>
                                                            </div>
                                                        </div>
                                                        :
                                                        <div>

                                                            <p className="m-0 p-1 text-danger register-btn-link" style={{whiteSpace:"nowrap"}}><svg style={{ fill: "#dc3545" }} xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#dc3545"><path d="M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q54 0 104-17.5t92-50.5L228-676q-33 42-50.5 92T160-480q0 134 93 227t227 93Zm252-124q33-42 50.5-92T800-480q0-134-93-227t-227-93q-54 0-104 17.5T284-732l448 448Z" /></svg> Registration Closed</p>

                                                            <div className='product__items--action__btn hand_cursor register-btn-icon' style={{ background: "#ffd2d2" }}>
                                                                <svg style={{ fill: "#dc3545" }} xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#dc3545"><path d="M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q54 0 104-17.5t92-50.5L228-676q-33 42-50.5 92T160-480q0 134 93 227t227 93Zm252-124q33-42 50.5-92T800-480q0-134-93-227t-227-93q-54 0-104 17.5T284-732l448 448Z" /></svg>
                                                            </div>
                                                        </div>
                                                    }
                                                </div>

                                            </div>

                                        </div>
                                    </div>
                                    : null
                            );
                        })}
                    </div>
                ) :
                    // <div className="product__section--inner py-5 text-center">
                    //     <img src={NoEventImg} alt="" style={{ width: 250 }} />
                    //     <h4 className="pt-4">No events found</h4>
                    //     <p>
                    //         Sorry, We couldn't find any events that match your search, <span style={{cursor: 'pointer', color: 'blue'}} onMouseOver={e => (e.target.style.fontWeight = 'bold')} onMouseOut={e => (e.target.style.fontWeight = 'normal')} onClick={(e) => HandleClear(e)} >See all events</span>.
                    //     </p>
                    // </div>


                        <div className="product__section--inner py-5 text-center">
                            <img src={NoEventImg} alt="" style={{ width: 250 }} />
                            <h4 className="pt-4">Oops! No Events Found</h4>
                            <p className='mb-1'>Sorry, We couldn't find any events that match your search.</p>
                            <h4 className="h4 register-btn-link d-block" onMouseOver={e => (e.target.style.fontWeight = 'bold')} onMouseOut={e => (e.target.style.fontWeight = 'normal')} onClick={(e) => HandleClear(e)} style={{cursor: 'pointer'}}>Explore All Events <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="currentColor"><path d="M647-440H160v-80h487L423-744l57-56 320 320-320 320-57-56 224-224Z" /></svg></h4>                             
                          </div>

            }
        </div>
    </div>
</div>
{/* END EVENTS LISTING TABLE START HERE */}

{Index < EventsData.length ?
    <div className="pagination__area bg__gray--color">
        <nav className="pagination justify-content-center">
            <div
                className="continue__shipping--btn secondary__btn border-radius-5"
                onClick={(e) => setIndex(Index + 9)}
                style={{ cursor: 'pointer' }}
            >
                Load more
            </div>
        </nav>
    </div>
    : null
}
</div>

                            </div>
                        </div>
                    </div>
                </section>
            </main >
        </>

    )
}

export default SearchEvent